import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import { Card,Box, Flex, Heading, Spacer, Td, Text, Tr } from "@chakra-ui/react";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import { get_inventory_list } from "../../redux/inventorySlice";
import { get_all_customer_list } from "../../redux/customerSlice";
import { get_all_dp_list } from "../../redux/dplistSlice";
import CustomSingleInput from "../../components/CustomSingleInput";
import { baseUrl } from "../../utils/utils";
import Loader from "../../components/Loader";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const ReceiptReports = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState(10);
  const [page, setPage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [total_count, setTotal_count] = useState(0);
  const [reports_list, setReports_list] = useState([]);
  const [loading, setLoading] = useState(false);
  const [excelUrl, setExcelUrl] = useState(null); // 🆕 added
  const { all_customer_list } = useSelector((state) => state.customers);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [data, setData] = useState({});
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
const [customerSearchTerm, setCustomerSearchTerm] = useState("");
const [filteredCustomerList, setFilteredCustomerList] = useState([]);
const [hasSearched, setHasSearched] = useState(false);

  const customer_list = all_customer_list?.map((v) => ({
    label: v?.name,
    value: v?.id,
  }));

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `inventory.php`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_inventory_list({ page, rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch {
      toast.error("Failed to load product data");
    } finally {
      setIsLoading(false);
    }
  };

  const get_report_list = async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append("action", "customer");
      formData.append("page", page);
      formData.append("limit", rows);
      formData.append("fd", startDate);
      formData.append("td", endDate);
      formData.append("userid", selectedProduct);

      const response = await fetch(`${baseUrl}reports/receipts_report.php`, {
        method: "POST",
        body: formData,
      });

      const res = await response.json();

      if (res?.success) {
        setReports_list(res?.list);
        setTotal_count(res.totalcount);
        setExcelUrl(res?.excel_url || null); // 🆕 Store Excel file URL if available
      } else {
        setReports_list([]);
        setTotal_count(0);
        setExcelUrl(null); // 🆕 Reset if no file found
      }
    } catch {
      console.log("Failed to fetch sales report");
      setExcelUrl(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    store.dispatch(get_all_customer_list());
  }, []);

  // useEffect(() => {
  //   if (selectedProduct && startDate && endDate) {
  //     get_report_list();
  //   }
  // }, [page, rows, selectedProduct, startDate, endDate]);

useEffect(() => {
  if (selectedProduct && startDate && endDate) {
    get_report_list(); // Always fetch when pagination or rows change
  }
  setInitialValue((page - 1) * rows + 1);
}, [page, rows]);


  // Filter customer list based on search term
useEffect(() => {
  if (customerSearchTerm) {
    const filtered = customer_list?.filter((customer) =>
      customer.label?.toLowerCase().includes(customerSearchTerm.toLowerCase())
    );
    setFilteredCustomerList(filtered || []);
  } else {
    setFilteredCustomerList(customer_list || []);
  }
}, [customerSearchTerm, all_customer_list]);

const handleSearch = () => {
  // Validation
  if (!startDate || !endDate) {
    toast.error("Please select both start and end dates");
    return;
  }
  if (!selectedProduct) {
    toast.error("Please select a customer");
    return;
  }

  // Reset pagination and trigger search
  setPage(1);
  setInitialValue(1);
 
  setData({
    sd: startDate,
    ed: endDate,
    pcode: selectedProduct,
  });
  get_report_list();
   setHasSearched(true);
};

  const handleRowsChange = (e) => {
    const newRows = Number(e.target.value);
    setRows(newRows);
    setPage(1);
    setInitialValue(1);
  };

  const handlePrevious = () => {
    if (page > 1) {
      setPage(page - 1);
      setInitialValue(initialValue - rows);
    }
  };

  const handleNext = () => {
    if (rows * page < total_count) {
      setPage(page + 1);
      setInitialValue(initialValue + rows);
    }
  };

  // 🆕 Function to handle Excel Download
  const handleDownloadExcel = () => {
    if (excelUrl) {
      const link = document.createElement("a");
      link.href = excelUrl;
      link.download = excelUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      toast.error("Excel file not available");
    }
  };

  // 🔥 Auto load when changing customer AFTER first search
useEffect(() => {
  if (hasSearched && selectedProduct && startDate && endDate) {
    setPage(1); // reset pagination when changing customer
    get_report_list();
  }
}, [selectedProduct]);

// 🔥 Auto run search when a customer is selected
useEffect(() => {
  // no customer selected → stop
  if (!selectedProduct) return;

  // no dates → stop
  if (!startDate || !endDate) return;

  // first time → do NOT auto load
  if (!hasSearched) return;

  // after first search → auto load
  setPage(1);
  get_report_list();
}, [selectedProduct]);


  const transactionModeMap = {
    0: "PhonePe",
    1: "Gpay",
    2: "Paytm",
    3: "Cred",
    4: "RTGS",
    5: "NEFT",
    6: "IMPS",
    7: "Others",
  };
  
  const paymentModeMap = {
    1: "Cash",
    2: "Online",
  };
  

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        flexDirection={["column", "row"]}
        alignItems={["flex-start", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading w="full" fontSize="xl">
          Receipt Reports
        </Heading>
        <Spacer display={["none", "block"]} />
      </Card>

      <Card bg="#fff" py={3} px={5}>
        <Flex direction={["column", "row"]} wrap="wrap" gap={3} mb={3}>
          <CustomSingleInput
            width={["100%", "200px"]}
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <CustomSingleInput
            width={["100%", "200px"]}
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
<Box width={["100%", "200px"]} position="relative">
  <CustomSingleInput
    label="Customer"
    width="100%"
    placeholder="Search Customer"
    type="text"
    value={
      selectedProduct
        ? filteredCustomerList.find((c) => c.value === selectedProduct)?.label || ""
        : customerSearchTerm
    }
    onChange={(e) => {
      setCustomerSearchTerm(e.target.value);
      setSelectedProduct(null);
      setShowCustomerDropdown(true);
    }}
    onFocus={() => setShowCustomerDropdown(true)}
  />
  
  {showCustomerDropdown && filteredCustomerList.length > 0 && (
    <Box
      position="absolute"
      top="100%"
      left={0}
      right={0}
      mt={1}
      maxH="240px"
      overflowY="auto"
      zIndex={1000}
      bg="white"
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
      boxShadow="md"
    >
      {filteredCustomerList.map((customer) => (
        <Flex
          key={customer.value}
          direction="column"
          p={3}
          cursor="pointer"
          bg={selectedProduct === customer.value ? "blue.50" : "white"}
          borderBottom="1px solid"
          borderColor="gray.100"
          _hover={{ bg: "gray.50" }}
          _last={{ borderBottom: "none" }}
onClick={() => {
  setSelectedProduct(customer.value);
  setShowCustomerDropdown(false);
  setCustomerSearchTerm("");
}}




        >
          <Text fontSize="sm" fontWeight="600" color="gray.800">
            {customer.label}
          </Text>
        </Flex>
      ))}
    </Box>
  )}
</Box>
          <CustomButton
            title="Search"
            w={["100%", "auto"]}
            onClick={handleSearch}
          />

          {/* 🆕 Show Download Button if Excel URL exists */}
          {excelUrl && (
            <CustomButton
              title="Download Excel"
              w={["100%", "auto"]}
              onClick={handleDownloadExcel}
              bg="#2E7D32"
              color="#fff"
            />
          )}
        </Flex>

        {data?.sd && (
          <Text>
            From Date: <b>{data.sd}</b> To Date: <b>{data.ed}</b> Sales Type:{" "}
            <b>
              {data.stype === "customer"
                ? "Customer"
                : data.stype === "product"
                ? "Product"
                : "Delivery Partner"}
            </b>{" "}
            {data.stype === "customer"
              ? "Customer Name"
              : data.stype === "product"
              ? "Product Name"
              : "Delivery Partner Name"}
            :{" "}
            <b>
              {customer_list?.find((v) => v.value === data.pcode)?.label}
            </b>
          </Text>
        )}
      </Card>

      {loading ? (
  <GasCylinderLoader />
) : hasSearched ? (
  reports_list?.length === 0 ? (
    <Card justify="center" align="center" h={20}>
      <Text>No Data</Text>
    </Card>
  ) : (
    <Card>
      <TableView
        headData={[
          "S.No.",
          "Voucher No.",
          "Transaction Number",
          "Transaction Mode",
          "payment mode",
          "Total Amount",
          "Voucher Date",
        ]}
        body={reports_list?.map((el, i) => (
          <Tr key={i}>
            <Td textAlign="center">{(page - 1) * rows + i + 1}</Td>
            <Td textAlign="center">{el.sr_no}</Td>
            <Td textAlign="center">{el.transaction_number || "NA"}</Td>

            {/* Transaction Mode */}
            <Td textAlign="center">
              {transactionModeMap[Number(el.mode_of_transaction)] || "NA"}
            </Td>

            {/* Payment Mode */}
            <Td textAlign="center">
              {paymentModeMap[Number(el.payment_mode)] || "NA"}
            </Td>

            <Td textAlign="center">{el.amount}</Td>
            <Td textAlign="center">{el.voucher_date}</Td>
          </Tr>
        ))}
        initialValue={initialValue}
        page={page}
        rows={rows}
        total_value={total_count}
        pagination
        onChange={(e) => {
          setRows(Number(e.target.value));
          setPage(1);
        }}
        onPrevious={() => {
          if (page > 1) {
            setPage(page - 1);
          }
        }}
        onNext={() => {
          if (page < Math.ceil(total_count / rows)) {
            setPage(page + 1);
          }
        }}
      />
      <ConfirmDialog
        isOpen={deleteDialog}
        onClose={() => setDeleteDialog(false)}
        onConfirm={handleDelete}
        type="delete"
        title="Delete Inventory"
        message="Are you sure you want to delete this Inventory? This action cannot be undone and will remove all associated data."
        confirmText="Delete"
        cancelText="Cancel"
        isLoading={isLoading}
      />
    </Card>
  )
) : null}
    </>
  );
};

export default ReceiptReports;
